/**
 * @title fsamodal.js: Sub-module for Global pages
 * @description This module is used to display the fsa modal
 * @dependency 
 */
define(['orderitems'], function(orderitems) {	
	
	var rxPrescriptionStatus = {
			
		init : function() {
			this.sortPrescriptionLists();
			this.setUpSortEventListeners();
			$("#inprocess-tertiary").trigger("click");
			$('#inprocess-checkout').hide();
			
			$('#order-refill').click(function() {
				COSTCO.rxPrescriptionStatus.orderRefills();
			});
		},
		//Sanitaize API Data.
		sanitize : function(unpurifiedData) {
			function replaceChars(ch){
				switch(ch){
					case "<":
						return "&lt;";
					case ">":
						return "&gt;";
					case "&":
						return "&amp;";
				}
				return "";
			}
			return unpurifiedData.replace(/[<>&]/g, replaceChars);
			 
		},
		getPathName : function(locationObj) {
			const pathName = $(locationObj).attr('pathname');
			let purifiedDataStr = COSTCO.rxPrescriptionStatus.sanitize(pathName);
			return purifiedDataStr;
		},
		
		url: {
			CHANGE_PRESCRIPTION_AUTOREFILL: '/AjaxPharmacyPrescriptionAutoRefillCmd'
		},
		
		/**
		 * Sorts inProcess, availableRefills and historyResults lists by order date
		 * @param (string) listType		Type of the list to order(In Process, Available Refills, Prescription History)
		 * @param (string) sortType 	Selected sorting type  
		 */
		sortPrescriptionLists: function(listType,sortType) {
			
			//On initial page load, sort by order date
			if(listType == "undefined" && sortType  == "undefined" || listType == undefined && sortType  == undefined || listType == null && sortType  == null){
				//Set all selects to initial value Sort by order date
				if (typeof inProcessResults != "undefined"){
					inProcessResults.sort(rxPrescriptionStatus['prescriptionSortByLastOrderedDesc']);
				}
				if (typeof availableRefillResults != "undefined"){
					availableRefillResults.sort(rxPrescriptionStatus['prescriptionSortByLastOrderedDesc']);
				}
				if (typeof historyResults != "undefined"){
					historyResults.sort(rxPrescriptionStatus['prescriptionSortByLastOrderedDesc']);
				}
				if (typeof onFileResults != "undefined"){
					onFileResults.sort(rxPrescriptionStatus['prescriptionSortByPrescriptionDateDesc']);
				}
			}else if(listType == "inProcessList" && typeof inProcessResults != "undefined"){
				inProcessResults.sort(rxPrescriptionStatus[sortType]);	
			}else if(listType == "availableRefillList" && typeof availableRefillResults != "undefined"){
				availableRefillResults.sort(rxPrescriptionStatus[sortType]);
			}else if(listType == "historyList" && typeof historyResults != "undefined"){
				historyResults.sort(rxPrescriptionStatus[sortType]);			
			}else if(listType == "onFileList" && typeof onFileResults != "undefined"){
				onFileResults.sort(rxPrescriptionStatus[sortType]);			
			}
		},
		
		/**
		 * Sets up event listeners for sorting prescription status list
		 */
		setUpSortEventListeners: function(){
			$('#inProcess-sort').on('change', function() {
				COSTCO.rxPrescriptionStatus.sortPrescriptionLists("inProcessList" ,this.value)
				inProcess_loadPrescriptionLists();
			});
			$('#availableRefills-sort').on('change', function() {
				COSTCO.rxPrescriptionStatus.sortPrescriptionLists("availableRefillList" ,this.value)
				available_refills_loadPrescriptionLists();
			});
			$('#history-sort').on('change', function() {
				COSTCO.rxPrescriptionStatus.sortPrescriptionLists("historyList" ,this.value)
				history_loadPrescriptionLists();
			});
			$('#onFile-sort').on('change', function() {
				COSTCO.rxPrescriptionStatus.sortPrescriptionLists("onFileList" ,this.value)
				available_refills_loadPrescriptionOnFileLists();
			});
		},
		
		/**
		 * Orders prescription list by order date
		 */
		prescriptionSortByLastOrderedDesc: function(prescriptionA, prescriptionB) {
			let prescriptionALastOrderedDate = prescriptionA.lastOrdered ? prescriptionA.lastOrdered : prescriptionA.lastOrderedDate ? prescriptionA.lastOrderedDate : '';
			let prescriptionBLastOrderedDate = prescriptionB.lastOrdered ? prescriptionB.lastOrdered : prescriptionB.lastOrderedDate ? prescriptionB.lastOrderedDate : '';			
			return new Date(prescriptionBLastOrderedDate).getTime() - new Date(prescriptionALastOrderedDate).getTime();
		},
		
		/**
		 * Orders prescription list by prescription date
		 */
		prescriptionSortByPrescriptionDateDesc: function(prescriptionA, prescriptionB) {
			let prescriptionAPrescriptionDate = prescriptionA.prescriptionDate ? prescriptionA.prescriptionDate :  '';
			let prescriptionBPrescriptionDate = prescriptionB.prescriptionDate ? prescriptionB.prescriptionDate :  '';			
			return new Date(prescriptionBPrescriptionDate).getTime() - new Date(prescriptionAPrescriptionDate).getTime();
		},
		
		/**
		 * Orders prescription list by drug name
		 */
		prescriptionSortByDrugName: function(prescriptionA, prescriptionB) {
			let prescriptionADrugName = prescriptionA.drugDescription ? prescriptionA.drugDescription : '';
			let prescriptionBDrugName = prescriptionB.drugDescription ? prescriptionB.drugDescription : '';		
			return ((prescriptionADrugName.toLowerCase() < prescriptionBDrugName.toLowerCase()) ? -1 : ((prescriptionADrugName.toLowerCase() > prescriptionBDrugName.toLowerCase()) ? 1 : 0));
		},
		
		/**
		 * Orders prescription list by type
		 */
		prescriptionSortByType: function(prescriptionA, prescriptionB) {
			let prescriptionAType = prescriptionA.type ? prescriptionA.type : '';
			let prescriptionBType = prescriptionB.type ? prescriptionB.type : '';			
			return ((prescriptionAType.toLowerCase() < prescriptionBType.toLowerCase()) ? -1 : ((prescriptionAType.toLowerCase() > prescriptionBType.toLowerCase()) ? 1 : 0));
		},
		
		/**
		 * Orders prescription list by refills left
		 */
		prescriptionSortByRefillsLeft: function(prescriptionA, prescriptionB) {
			let prescriptionARefillsLeft = prescriptionA.refillsLeft ? prescriptionA.refillsLeft : 0;
			let prescriptionBRefillsLeft = prescriptionB.refillsLeft ? prescriptionB.refillsLeft : 0;			
			return prescriptionARefillsLeft - prescriptionBRefillsLeft;
		},
		
		/**
		 * Orders prescription list by auto refill, possible values 0-2 N/A, if the value is N/A or empty replace it with number 4
		 */
		prescriptionSortByAutoRefill: function(prescriptionA, prescriptionB) {
			let prescriptionAAutoRefill = prescriptionA.autoRefill ? !isNaN(prescriptionA.autoRefill) ? prescriptionA.autoRefill : 4 : 4;
			let prescriptionBAutoRefill = prescriptionB.autoRefill ? !isNaN(prescriptionB.autoRefill) ? prescriptionB.autoRefill : 4 : 4;	
			return prescriptionAAutoRefill - prescriptionBAutoRefill;
		},
		
		/**
		 * Orders prescription list by ship date
		 */
		 prescriptionSortByShipDate: function(prescriptionA, prescriptionB) {
			let prescriptionAShipDate = prescriptionA.shipDate ? prescriptionA.shipDate : '';
			let prescriptionBShipDate = prescriptionB.shipDate ? prescriptionB.shipDate : '';		
			return new Date(prescriptionBShipDate).getTime() - new Date(prescriptionAShipDate).getTime();
		},
		
		/**
		 * Handles click on select checkbox on Available Refills tab
		 * @param {number} prescriptionId 	Prescription id
		 * @param {string} element       	HTML element user clicked on
		 * @param {number} refillsLeft      refills left for element user clicked on
		 */
		managePrescriptionSelection: function(prescriptionId, element, refillsLeft) {
			rxPrescriptionStatus.setPrescriptionSelectionInJSON(availableRefillResults, prescriptionId, element);
			
			if (combinedResults != undefined && combinedResults.length > 0)
				rxPrescriptionStatus.setPrescriptionSelectionInJSON(combinedResults, prescriptionId, element);
			else 
				rxPrescriptionStatus.setPrescriptionSelectionInJSON(availableRefillResults, prescriptionId, element);
			
			
			/* DFCT0015940: commented out as part of defect resolution */
//			if(refillsLeft < 1) {
//				$('#prescriptionNumber_' + prescriptionId).tooltip({'trigger':'focus', 'title': 'Password tooltip'});
//			} else {
//				rxPrescriptionStatus.setPrescriptionSelectionInJSON(availableRefillResults, prescriptionId, element);
//			}
			
		},
	
		// Handles showing notification when click on Order Refill checkbox on Available Refills tab
		showNotification: function(prescriptionId){		
			let rxRefillbody = $('#available-refills-prescriptions-body');
			let rxRefillWarning = $('#available-refills-notification-' + prescriptionId);
			let rxRefillWarningContainer = $('#available-refills-prescriptions-warning');

			$(rxRefillWarning).toggleClass('hide');
			if (!$(rxRefillWarning).hasClass('hide')) {
				$(rxRefillbody).css('border-bottom', 'none');
				$(rxRefillWarningContainer).css('border-bottom', '1px solid #cccccc');
			} else {
				$(rxRefillbody).css('border-bottom', '1px solid #cccccc');
				$(rxRefillWarningContainer).css('border-bottom', 'none');
			}
		},
	
		/**
		 * Iterates through provided JSON array and sets 'checked' property to match user selection
		 * @param {JSON Array} prescriptionJSON 	Prescription JSON array to update
		 * @param {number} prescriptionId   		User selected prescription
		 * @param {Object} element          		Selected prescription input html element
		 */
		setPrescriptionSelectionInJSON: function(prescriptionJSON, prescriptionId, element) {
			$.each(prescriptionJSON, function(index, value) {
				if (value.prescriptionId == prescriptionId) {
					value.checked = $(element).prop('checked'); 
					
				}
			});
		},
		
		selectedResults : [],
		/**
		 * Handles click on select checkbox on In Process tab
		 * @param {number} prescriptionId 	Prescription id
		 */
		inProcessManageSelect : function(prescriptionId){
			
			var rxArray = COSTCO.rxPrescriptionStatus.selectedResults;
			var rxIndex = COSTCO.rxPrescriptionStatus.selectedResults.indexOf(prescriptionId);
			let messageField = '#multiple-prescriptions';
			
			if(rxIndex < 0){
				rxArray.push(prescriptionId);
			}else{
				rxArray.splice(rxIndex,1);
			}
			
			if (rxArray.length > 0) {
				$('#inprocess-checkout').show();
			}else{
				$('#inprocess-checkout').hide();
				$(messageField).hide();
			}
		},
		/**
		 * Method to handle the deselect function 
		 * for if a prescription with a different
		 * patientId is already available
		 */
		deselectPrescription: function () {
			let messageField = '#multiple-prescriptions';
			var rxArray = COSTCO.rxPrescriptionStatus.selectedResults;
			var patientName="";
			if(typeof currentPharmacyOrderDetails!= undefined && currentPharmacyOrderDetails.length >0){
				var currentOrderPatientId = currentPharmacyOrderDetails[0].patientId;
				for(let i=0; i<patientListDetails.length;i++){
					if(patientListDetails[i].shopperId===currentOrderPatientId) {
						patientName = patientListDetails[i].firstName;
					}
				}

			}
			var message = messages.DESELECT_PRESCRIPTION_IN_BASKET.replace("{0}",patientName);
			if(rxArray.length > 0) {
				for(var i=0; i<rxArray.length;i++) {
					var prescriptionId = rxArray[i];
					$('#prescriptionNumber_' + prescriptionId).attr("checked", false);
					$('#prescriptionNumber_' + prescriptionId).attr("aria-checked", false);
					if (i === rxArray.length-1) {
						$('#inprocess-checkout').hide();
					} 
				}
				$(messageField).removeClass('critical-notification');
				$(messageField).addClass('general-notification');
				$(messageField)[0].innerHTML = message;
				$(messageField).addClass('aria-selected="true"');
		    	$(messageField)[0].focus();
				$(messageField)[0].scrollIntoView();
		    	COSTCO.rxPrescriptionStatus.selectedResults.splice(0,rxArray.length);
			}
		},

		/**
		 * Method to remove the prescriptions
		 * for a different patientId already available
		 * in cart 
		 */
		removePrescriptionsFromCart: function () {
			let messageField = '#multiple-prescriptions';
			if(typeof currentPharmacyOrderDetails!= undefined && currentPharmacyOrderDetails.length >0){
				var formData = {};
				formData['actionType'] = 'delete';
		    	formData['ajaxFlag'] = true;
		    	//setting the orderId from first Object as we need it only once
		    	formData['orderId']=currentPharmacyOrderDetails[0].orderId;
		    	formData['isPharmacy']=true;
		    	formData['isRestrictedPostalCode']=false;
		    	var paramCount = 1;
		    	for(let i=0; i<currentPharmacyOrderDetails.length;i++) {
		    		formData['orderItem_' + paramCount] = currentPharmacyOrderDetails[i].orderItemId;
		    		formData['catalogEntryId_' + paramCount] = currentPharmacyOrderDetails[i].catentryId;
		    		formData['prescriptionId_'+paramCount]= currentPharmacyOrderDetails[i].prescriptionId;
		    		formData['quantity_' + paramCount] = 0;
		    		paramCount++;
		    	}
				COSTCO.AjaxModular.ajax_update_state({
	        		method: 'POST',
	        		url: '/AjaxManageShoppingCartCmd',
	        		data: formData,
	        		dataType: 'json',
	        		error_container: messageField,
	        		done: function(data, textStatus, jqXHR, options) {
	        			if (data.error !== undefined && (data.error.application.length > 0)) {
	        				$(messageField).addClass('critical-notification');
	    					$(messageField)[0].innerHTML = error.mesage;
	    			    	$(messageField).show();
	    			    	$(messageField).addClass('aria-selected="true"');
	    			    	$(messageField)[0].focus();

	        			} else{
	        				COSTCO.Header.miniShopCartRefresh();
	        				COSTCO.OrderItems.addQuantityEventHandlers();
	        				$(messageField).removeClass('critical-notification');
	        				$(messageField).addClass('success-notification');
	        				$(messageField)[0].innerHTML = messages.REMOVE_PRESCRIPTIONS_IN_CART;
	        		    	$(messageField).show();
	        		    	$(messageField).addClass('aria-selected="true"');
	    			    	$(messageField)[0].focus();
	        		    	$(messageField)[0].scrollIntoView();
	        		    	currentPharmacyOrderDetails={};
	        			}
	        		}
	        	});
			}
		},

		/**
		 * Populates hidden input field on In Process tab for form submit
		 * @param {string} formId 	Form Id to append the input field
		 */
		buildSelectedPrescriptionHiddenInput: function (formId) { 
			let messageField = '#multiple-prescriptions';						
			var currentOrderShopperId ="";
			if(typeof currentPharmacyOrderDetails!= undefined && currentPharmacyOrderDetails.length >0){
				for(let i=0; i<currentPharmacyOrderDetails.length;i++) {
					currentOrderShopperId= currentPharmacyOrderDetails[0].patientId;
					break; 
				}
			}
			if(selectedShopperId === currentOrderShopperId ||currentOrderShopperId=="" ) {
				$('input[id^=prescriptionNumber]').remove();
				// Append a hidden input field to the form that will have the selected prescription ids
				$("<input type='hidden'/>").attr({'id':'rxPrescriptionNumber', 'name':'rxPrescriptionNumber', 'value':COSTCO.rxPrescriptionStatus.selectedResults.join(',')}).appendTo("#"+formId);
				document.getElementById(formId).submit();
				}
			// display error message if the cart has a prescription with different patient Id
			else {
					$(messageField).addClass('critical-notification');
					$(messageField)[0].innerHTML = messages.ERR_MULTIPLE_PRESCRIPTION_IN_BASKET;
			    	$(messageField).show();
			    	$(messageField).addClass('aria-selected="true"');
			    	$(messageField)[0].focus();
			    	$(messageField)[0].scrollIntoView();
				}
		},
		/**
		 * Handles on click auto refill radio button
		 * @param {number} autoRefill       Radio button user clicked (0 - off | 1 - on)
		 * @param {number} prescriptionId 	Prescription id
		 */
		managePrescriptionAutoRefill: function(autoRefill, prescriptionId) {
			COSTCO.Checkout.ajax_update_state({
		        error_container: '#error-container',
		        method: 'POST',
		        url: rxPrescriptionStatus.url.CHANGE_PRESCRIPTION_AUTOREFILL,
		        data: { prescriptionId: prescriptionId, autoRefill: autoRefill },
		        dataType: 'json',
		        done: function(data, textStatus, jqXHR, options) {
	        		if (data.payload.data.numberOfPrescriptionsUpdated != 1) {						
	        			rxPrescriptionStatus.revertAutoRefillUserSelection(prescriptionId);	
					} else {
						if (data.payload.data.patientAutoRefillReminder == 'false' && autoRefill == 1) {
							rxPrescriptionStatus.openEnableAutoRefillReminderDialog();
						}
						if (options.data.status == 'inactive') {
							COSTCO.Checkout.ajax_update_default_done(data, textStatus, jqXHR, options);
						}
						availableRefillResults.find((result, index) => {
						    if (result.prescriptionId == prescriptionId) {
						    	availableRefillResults[index].autoRefill = autoRefill;
						    }
						});
					}
				}
			});
		},
		/**
		 * Displays Need Help modal
		 */
		displayNeedHelp: function() {
			var activeTab = $('#navigation-tabs .active').find('a').attr("href").split('-')[0].substr(1);

			COSTCO.dialog.createExtDialogBox({
				title: messages.RWD_PRESCRIPTION_STATUS_HELP,
				body: COSTCO.util.tmpl('prescription_status_need_help_modal', {}),
				primary: messages.JS_DIALOG_CLOSE,
				
				onshown: function onshown() {
					$('div[id^=' + activeTab + ']>p a').each(function () {
						$(this).click();
					});
				}
				
			});
		},
		/**
		 * Opens AutoRefill Reminder dialog
		 */
		openEnableAutoRefillReminderDialog: function() {	
			COSTCO.dialog.createExtDialogBox({
				title: messages.ENABLE_AUTOREFILL_REMINDER_DIALOG_TITLE,
				body: messages.ENABLE_AUTOREFILL_REMINDER_DIALOG_CONTENT,
				primary: messages.JS_DIALOG_OK,
			});
		},
		/**
		 * Opens info dialog when user clicks Order Refill button without selecting any prescription
		 */
		openChangePrescriptionStatusInfoDialog: function() {
			COSTCO.dialog.createExtDialogBox({
				title: messages.PRESCRIPTION_PHARMACY__Info_DialogTitle,
				body: messages.HDREFILL_PRESCRIPTION_PHARMACY__SelectAPrescriptionOrderRefill, 
				primary: messages.JS_DIALOG_OK, 
			});
		},
		/**
		 * Reverts auto refill user selection to initial state from prescription JSON 
		 * @param  {number} prescriptionId 	Id of prescription to revert
		 */
		revertAutoRefillUserSelection: function(prescriptionId) {
			let presc = rxPrescriptionStatus.getPrescriptionJSONById(availableRefillResults, prescriptionId);
			if (presc != undefined) {
				if (presc.autoRefill == 0) {
					$('#autoRefillDisabled_' + prescriptionId).prop('checked', true);		

				} else if (presc.autoRefill == 1) {
					$('#autoRefillEnabled_' + prescriptionId).prop('checked', true);
				}
			} 
		},
		/**
		 * Gets prescription JSON from input JSON array by ID
		 * @param  {JSON Array} 	prescriptionJSON 	Prescription JSON array
		 * @param  {number} 		prescriptionId   	Id of prescription to find in JSON array
		 * @return {JSON Object}	Found prescription
		 */
		getPrescriptionJSONById: function(prescriptionJSON, prescriptionId) {

			let json;
			$.each(prescriptionJSON, function(index, value) {
				if (value.prescriptionId == prescriptionId) {
					json = value;
					return false;
				}
			});

			return json;
		},
		/**
		 * Handles click on order refills button in Available Refills tab
		 */
		orderRefills: function() {
			let selectedPrescriptionIds = rxPrescriptionStatus.getSelectedPrescriptionIds();
			if (selectedPrescriptionIds.length) {
				var refillForm = $('#available-refill-form');
				refillForm.append('<input type="hidden" name="rxPrescriptionNumber" value="' + selectedPrescriptionIds.join(",") + '" />');
				refillForm.submit();
			} else {
				rxPrescriptionStatus.openChangePrescriptionStatusInfoDialog();
			}
		},
		/**
		 * Returns prescriptions selected by user
		 */
		getSelectedPrescriptionIds: function() {
			let selectedPrescriptions = [];
			let tmpPrescriptionsArray = [];
			tmpPrescriptionsArray = availableRefillResults;
			$.each(tmpPrescriptionsArray, function(index, value) {
				if(value.checked == true) {
					selectedPrescriptions.push(value.prescriptionId);
				}
			});
			tmpPrescriptionsArray = onFileResults;
			$.each(tmpPrescriptionsArray, function(index, value) {
				if(value.checked == true) {
					selectedPrescriptions.push(value.prescriptionId);
				}
			});
			return selectedPrescriptions;	
		},
		/**
		 * Gets JSON array of active or inactive prescriptions to be displayed on page
		 * @param {string} status 	Status of prescriptions to display ('active' | 'inactive')
		 * @param {number} pageNum 	Page number; Default set to 1
		 * @param {number} rowsNum 	Number of records to be displayed; Default set to 10
		 * @return Prescriptions JSON Array to be displayed on page, based on pageNum, rowsNum count and prescription status
		 */
		getPrescriptionsJSON : function(status, pageNum, rowsNum) {
							
			let resultArray = [];
			
			if (pageNum == undefined) {
				pageNum = 1;
			}
			
			if (rowsNum == undefined) {
				rowsNum = 10;
			}
			
			let beginIndex = (pageNum * rowsNum) - rowsNum;
			let endIndex = pageNum * rowsNum - 1;
			
			let prescriptionsJson = [];
			if(status == "history") {
				prescriptionsJson = historyResults;
			} else if (status == "available_refills") {
				prescriptionsJson = availableRefillResults;
			} else if (status == "inprocess"){
				prescriptionsJson = inProcessResults;
			} else if (status == "onFile"){
				prescriptionsJson = onFileResults;
			}
			
			
			$.each(prescriptionsJson, function(index, value) {
				if (beginIndex <= index && index <= endIndex) {
					resultArray.push(value);
				}
			});
			
			return resultArray;
		},
		
		noRefillPopup: function (isMedicare) {
			var popupDiv = '#no-refill-popup';
			if(isMedicare){
				popupDiv = '#no-refill-popup-medicare';
			}
			
			COSTCO.dialog.createExtDialogBox({
				title:messages.REFILL_PRESCRIPTION_TITLE_NOREFILL,
				body: $(popupDiv).html(),
				primary: messages.JS_DIALOG_OK,
				primary_event: ()=> {
			          COSTCO.dialog.close();
				},
			
			});
			
		},
			
		buildPrescriptionDetail : function(details, centralFill,disableAutoRefill) {
			let SELF_CHECKOUT_DELIVERY = messages.PRESCRIPTION_DETAIL__Delivery_Self_Checkout;
			let AUTO_CHECKOUT_DELIVERY = messages.PRESCRIPTION_DETAIL__Delivery_Auto_Checkout;
			let SHIPPED_STATUS = messages.PRESCRIPTION_DETAIL__Delivery_Shipped;
			let AWAITING_PAYMENT = messages.PRESCRIPTION_STATUS_DESC__AwaitingPayment;
			let ORDERED = messages.PRESCRIPTION_STATUS__Ordered;
			let ON_FILE = messages.PRESCRIPTION_STATUS__OnFile;
			
			$("#detail-medication-h4").html(details.prescriptionName);
			
			let fullName = details.firstName + " " + details.lastName;
			$("#detail-patient").html(fullName);
			$("#detail-prescriptionId").html(details.rx);
			$("#detail-status").html(details.status);
			
			if (details.orderNumber == 0) {
				details.orderNumber = '&nbsp;';
			}
			
			$("#detail-costcoOrder").html(details.orderNumber);
			$("#detail-medication").html(details.prescriptionName);
			
			if(details.quantity == 0) {
				details.quantity = '&nbsp;';
			}
			
			$("#detail-quantity").html(details.quantity);
			
			//Display notification if prescription is expired or no refills
			if(details.isExpired){
				$("#detail-refillsLeft").html(messages.PHARMACY_EXPIRED);
				
				// Shows expired notification on the Prescription Details Page
				$('#prescription-details-expired-notification').removeClass('hide');
				
			} else if(details.refillsLeft == messages.REFILLS_LEFT_0 && details.autoRefill != messages.AUTOREFILL_VALUE_3) {
				// Shows no refills notification on the Prescription Details Page
				// Don't show if autoRefill value is 3 (NCD restricted)
				$("#prescription-details-no-refills-notification").removeClass('hide');
	
				$("#detail-refillsLeft").html(details.refillsLeft);
			}else {
				$("#detail-refillsLeft").html(details.refillsLeft);
			}
			
			$("#detail-expirationDate").html(details.expirationDate);
			
			let autoRefill = "NO";
			if (details.autoRefill == 1) {
				autoRefill = "YES";
			} else if(details.autoRefill == 3 || details.status == ON_FILE){
				autoRefill = "<a href='javascript:COSTCO.rxPrescriptionStatus.noRefillPopup(false);'>N/A</a>";
			}
			
			// Do not display notification if prescription is of type new or transfer or null (n/a), and with fill status of new, in process, or cancelled			
			let rxType = details.type.toLowerCase();
			let fillStatus = details.status.toLowerCase();			
			if(rxType == messages.PHARMACY_NEW || rxType == messages.PHARMACY_TRANSFER || rxType == messages.PHARMACY_NOT_AVAILABLE) {
				if(fillStatus == messages.PHARMACY_NEW || fillStatus == messages.PHARMACY_INPROCESS || fillStatus == messages.PHARMACY_CANCELLED){
					// Hides no refills notification on the Prescription Details Page
					$("#prescription-details-no-refills-notification").addClass('hide');
				}
			}	
			
			//Do not display notification if prescription has a fill status of 20 (on file)
			if(fillStatus == messages.PHARMACY_ON_FILE){
				$("#prescription-details-no-refills-notification").addClass('hide');
			}
					
			if(disableAutoRefill==true)
				autoRefill="<a href='javascript:COSTCO.rxPrescriptionStatus.noRefillPopup(true);'>N/A</a>";
			
			$("#detail-autoRefill").html(autoRefill);
			$("#detail-deliveryPreference").html(details.deliveryPreference + ':');
			
			/* handling the ship method, tracking # and tracking # URL */
			$("#notify-when-ready").show();
			$("#ship-when-ready").show();
			
			if (details.deliveryPreference == AUTO_CHECKOUT_DELIVERY) {
				$("#notify-when-ready").hide();
			} else if (details.deliveryPreference == SELF_CHECKOUT_DELIVERY) {
				$("#ship-when-ready").hide();
			}
			
			if (details.deliveryPreference == AUTO_CHECKOUT_DELIVERY ||
			   (details.deliveryPreference == SELF_CHECKOUT_DELIVERY &&
			    (details.status == SHIPPED_STATUS || details.status == AWAITING_PAYMENT || details.status == ORDERED))) {
				$("#detail-shippingOption").html(details.shipMethod);
				
				let trackingNumberUrl = (details.trackingNumberUrl == '#' || details.trackingNumberUrl == '') ? 'javascript:void(0);' : details.trackingNumberUrl;
				
				let trackingNumberLink = "<a class='external' href='"+trackingNumberUrl+"'>"+details.trackingNumber+"</a>" ;
				
				$("#detail-trackingNumber").html(trackingNumberLink);
			} else {
				$("#detail-shippingOption").html('');
				$("#detail-trackingNumber").html('');
			}
			
			var physicianDetail= "";
			if (details.physicianName != "" || details.physicianCity != "" || details.physicianState != "" || details.physicianPhone != "") {
				physicianDetail = details.physicianName + ", " + details.physicianCity + ", " + details.physicianState + ", " + details.physicianPhone;
			}
			$("#detail-physician").html(physicianDetail);
			
			var price = "";
			if (details.price != "" || details.rx) {
				price = COSTCO.util.formatMoney(details.price, true);
			}
			$("#detail-price").html(price);
			
			$("#detail-centralFillName").html(centralFill.name);
			$("#detail-centralFillStreet").html(centralFill.street);
			var cityStZip = centralFill.city + ", " + centralFill.state + " " + centralFill.zip;
			$("#detail-centralFillCityStZip").html(cityStZip);
			$("#detail-centralFillPhone").html(centralFill.phone);
			$("#detail-centralFillFax").html(centralFill.fax);
		},

		showRxDetail : function(rxNumberContainer, prescriptionId) {
			console.log(prescriptionId);
			
			let tabName = $(rxNumberContainer).attr('sectionid').split('-')[0];
			
			let shipDate = $(rxNumberContainer).attr('shipdate');
			let orderDate = $(rxNumberContainer).attr('orderdate');
			
			$(".back-to-status").show();
			$("#prescription-detail-dialog").fadeIn("fast");
			$("#prescription-status").hide();
			
			if(prescriptionId < 0) {
				prescriptionId *= -1;
			}
			$.ajax({
				type: "POST",
				url: prescriptionDetailUrl,
				dataType: 'json',
				data: {prescriptionId: prescriptionId},
				cache: false,
				success: function(data) {
					COSTCO.rxPrescriptionStatus.displayPrescriptionDtls(data,shipDate,orderDate,tabName);
				}, 
				error: function(xhr, ajaxOptions, thrownError) {
					window.location.href = prescriptionStatusUrl;
					console.log(xhr + " " + ajaxOpstions + " " + thrownError);
				}
			});
			
		},
		displayPrescriptionDtls: function(data,shipDate,orderDate,tabName){
			console.log(data);
			var prescriptionDetail 	= $.parseJSON(data.prescriptionDetail);
			var centralFill 		= $.parseJSON(data.centralFill);
			var disableAutoRefill 	= $.parseJSON(data.disableAutoRefill);
			$.when(COSTCO.rxPrescriptionStatus.buildPrescriptionDetail(prescriptionDetail, centralFill, disableAutoRefill)).then(
				function() {
					$(".desktop-title").html(messages.PRESCRIPTION_STATUS__DetailsPageHeader);
					$(".desktop-title-progress-meter .rx-desktop-title h1").html(messages.PRESCRIPTION_STATUS__DetailsPageHeader);
					
					$('#detail-orderDate').html(orderDate);
					
					if(tabName === 'available_refills' || tabName === 'history') {
						
						if(shipDate == '') {
							shipDate = '&nbsp;';
						}
						
						$("#detail-dateShipped").html(shipDate);
						$("#date-shipped-section").show();
						$("#tracking-number-section").show();
					} else {
						$("#date-shipped-section").hide();
						$("#tracking-number-section").hide();
					}
					
					if (window.innerWidth >= 1025) {
						COSTCO.util.adjustDivHeights('.adjust-height-upper-row-xl');
						COSTCO.util.adjustDivHeights('.adjust-height-lower-row-xl');
					}
					return false;
				}
			
			);
			
		},
		closeDetail: function() {
			$(".back-to-status").hide();
			$("#prescription-status").fadeIn("fast");
			$("#prescription-detail-dialog").hide();
			$(".rx-desktop-title h1").html(messages.PRESCRIPTION_STATUS__PageMainHeader);
			$("#prescription-details-no-refills-notification").addClass('hide');
			$('#prescription-details-expired-notification').addClass('hide');
		},

		/**
		 * Normalize values to help in string matching functions
		 */
		normalizeValues : function(data){
			if (data.status != null){

				let statusNormalized = data.status.toLowerCase().replace(/ /g,'');
				data.statusNormalized = statusNormalized;
				data.needsColumn = $('#inprocess-select-column').length > 0;
			}
			return data;
		},
		
		/**
		 * Creates prescriptions section table with pagination, based on template and status 
		 * @param  {string} status               Prescription status (inprocess|available_refills|history|onFile)
		 * @param  {string} prescriptionsBlockId HTML block ID to be populated with prescription rows
		 * @param  {number} pageNum              Page number to show
		 * @param  {number} rowsNum              Prescription rows per page
		 * @param  {number} numOfPages           Total number of pages
		 */
		createPrescriptionsSection : function(status, prescriptionsBlockId, pageNum, rowsNum, numOfPages, totalRecordsNum) {
			
			$('#' + prescriptionsBlockId).html('');
			
			let prescriptions = this.getPrescriptionsJSON(status, pageNum, rowsNum);
			
			// If inside 'In Process' tab there is at least one row with 'Add To Cart' checkbox, a modified design will be applied
			let hasAddToCart = false;
			if (status == "inprocess") {
				$.each(prescriptions, function(index, value) {
					value = COSTCO.rxPrescriptionStatus.normalizeValues(value);
					if (value.statusNormalized == 'addtocart') {
						hasAddToCart = true;
					}
				});
				if (hasAddToCart) {
					$('h6#status-header').addClass('align-with-label');
				} else {
					$('h6#status-header').removeClass();
				}
			}
			
			let templateId = 'prescription_status_' + status + ((status == "inprocess" && hasAddToCart) ? '_hasAddToCart' : '') + '_prescription_row';
			
			$.each(prescriptions, function(index, value) {
				
				value = COSTCO.rxPrescriptionStatus.normalizeValues(value);
				
				//DFCT0015134: Nikola - Dollar Symbol is missing under the Price section
				if (value.price && value.price.indexOf('$') === -1) {
					value.price = COSTCO.util.formatMoney(value.price, true);
				}
				value.groupIndex = index +1;
				
				let template = COSTCO.util.tmpl(templateId, value);
				
				template = $(template);
				
				if (value.checked == true) {
					template.find('#prescriptionNumber_' + value.prescriptionId).prop('checked', true);
				}

				template.find('#autoRefillEnabled_' + value.prescriptionId).prop('checked', value.autoRefill == '1' ? true : false);
				template.find('#autoRefillDisabled_' + value.prescriptionId).prop('checked', value.autoRefill == '0' ? true : false);
				if(template.find('#autoRefillDisabled_' + value.prescriptionId) && (value.autoRefill == 3)) {
					setTimeout(function(){ 
					let clearView = '';
					let autoRefill="<a href='javascript:COSTCO.rxPrescriptionStatus.noRefillPopup(false);'>N/A</a>";
					$('#autoRefillOptions_' + value.prescriptionId).html(clearView);
					$('#autoRefillOptions_' + value.prescriptionId).html(autoRefill);
					}, 100);
				}
				$('#' + prescriptionsBlockId).append(template); 
				
			});

			let paginationBlockId = status + '-page-numbers';
			let pageStatsBlockClass = status + '-paging-navigation';
			
			// Show upper paging navigation
			let firstRecordIndex = (pageNum - 1) * rowsNum + 1;
			let lastRecordIndex = (pageNum * rowsNum < totalRecordsNum) ? (pageNum * rowsNum) : totalRecordsNum; 
			$('#' + status + '-paging-navigation').html(COSTCO.util.tmpl('prescription_upper_paging_navigation', {
				firstRecordIndex: firstRecordIndex,
				lastRecordIndex: lastRecordIndex,
				totalRecordsNum: totalRecordsNum
			}));
			
			if ($('#' + paginationBlockId).length) {
				let optionsPaginationJson = {
						'templateId' : 'prescription_status_pagination_tmpl',
						'rowsNum' : rowsNum,
						'totalRecordsNum' : totalRecordsNum,
						'prescriptionsBlockId' : prescriptionsBlockId,
						'pageStatsBlockClass' : pageStatsBlockClass,
						'paginationBlockId' : paginationBlockId,
						'status' : status
					}
				this.createPagination(pageNum, optionsPaginationJson);
			}
		},
		/**
		 * Creates search results pagination.
		 * 
		 * @param {number} 		currentPage 			Current page number
		 * @param {JSON Object} optionsPaginationJson	various options for pagination
		 */
		createPagination: function(currentPage, optionsPaginationJson) {
			
			let totalPages = parseInt((optionsPaginationJson.totalRecordsNum - 1) / optionsPaginationJson.rowsNum + 1);
			let paginationBlockId = optionsPaginationJson.paginationBlockId;
			let templateId = optionsPaginationJson.templateId;
			let status = optionsPaginationJson.status;
			
			if ((totalPages > 1) && $('#' + paginationBlockId).length) {
				
				let $pagination = $('<ul/>');
				
				// Left arrow
				if (currentPage > 1) {
					$pagination.append(COSTCO.util.tmpl(templateId, this.createPageJson(optionsPaginationJson, currentPage - 1, '', 'co-arrow-left')));
				}
				
				// Display all page numbers, if number of pages less or equal to 5
				if (totalPages <= 5) {
					for (page = 1; page <= totalPages; page++) {
						$pagination.append(COSTCO.util.tmpl(templateId, this.createPageJson(optionsPaginationJson, page)));
					}
				
				// Display page numbers and ellipses, if number of pages is greater than 5
				} else {
					
					// Calculate start and end page number to be displayed, relative to current page
					let startPage = currentPage - 1;
					let endPage = currentPage + 1; 
					
					if (startPage < 2) {
						startPage = 2;
						endPage = 4;
					} else if (endPage > totalPages - 2) {
						startPage = totalPages - 3;
						endPage = totalPages - 1;
					}
					
					// Page 1 - Always display
					$pagination.append(COSTCO.util.tmpl(templateId, this.createPageJson(optionsPaginationJson, 1)));
					
					// Ellipsis
					if (startPage > 2) {
						$pagination.append(COSTCO.util.tmpl('prescription_status_hellip_tmpl'));
					}
					
					// Display page numbers startPage-endPage
					for (page = startPage; page <= endPage; page++) {
						$pagination.append(COSTCO.util.tmpl(templateId, this.createPageJson(optionsPaginationJson, page)));
					}
					
					// Ellipsis
					if (endPage < totalPages - 1) {
						$pagination.append(COSTCO.util.tmpl('prescription_status_hellip_tmpl'));
					}
					
					// Last page - always display
					$pagination.append(COSTCO.util.tmpl(templateId, this.createPageJson(optionsPaginationJson, totalPages)));
				}
				
				// Right arrow
				if (currentPage < totalPages) {
					$pagination.append(COSTCO.util.tmpl(templateId, this.createPageJson(optionsPaginationJson, currentPage + 1, '', 'co-arrow-right')));
				}
				
				// Mark current page active
				$pagination.find('#page-' + currentPage).addClass('btn-primary');
				
				$('#' + paginationBlockId).html($pagination);
			}
		},
		/**
		 * Helper function used in rxsearch.createPagination().
		 * Creates JSON that represents page HTML element.
		 * 
		 * @param {Object} pageJson Page JSON with predefined fields.
		 * @param {number} page Page number.
		 * @param {string} pageText The text to be displayed, defaults to page.
		 * @param {string} pageClass HTML class of the page element.
		 * @return {Object} JSON that represents page HTML element.
		 */
		createPageJson: function(pageJson, page, pageText, pageClass) {
			if (pageJson.constructor === {}.constructor) {
				pageJson.page = page;
				pageJson.pageText = pageText != undefined ? pageText : page;
				pageJson.pageClass = pageClass != undefined ? pageClass : '';
			} else {
				console.error('Expected object as parameter.');
			}
			return pageJson;
		},
		/**
		 * Toggles show / hide display of onFile prescription list on PrescriptionStatus webpage
		 * @param {String} section 	specifies which prescription list section to toggle
		 */
		showHideToggle : function() {

			const showHideButton = $('#onFile-prescriptions-toggle');
			const divWrapper = $(showHideButton).closest('#prescription-info-list-block');
			const prescriptionWrapper = $(divWrapper).find('.prescription-info-list')
			const icon = $(showHideButton).find('i');
			const span = $(showHideButton).find('span');
		
			if ($(showHideButton).hasClass('show-list')) {
				$(showHideButton).removeClass('show-list');
				$(icon).removeClass('rotate270');
				$(showHideButton).addClass('hide-list');
				$(icon).addClass('rotate90');
				$(span).text(messages.RWD_COMPARE_SHOW);
				$(showHideButton).find('.paging-navigation .text-right').hide();
				$(prescriptionWrapper).hide();
				$(showHideButton).attr('aria-label', messages.REFILL_PRESCRIPTION_SHOW_ONFILE_TOGGLE);
			} else {				
				$(showHideButton).removeClass('hide-list');
				$(icon).removeClass('rotate90');
				$(showHideButton).addClass('show-list');
				$(icon).addClass('rotate270');
				$(span).text(messages.RWD_COMPARE_HIDE);
				$(showHideButton).find('.paging-navigation .text-right').show();
				$(prescriptionWrapper).show();
				$(showHideButton).attr('aria-label', messages.REFILL_PRESCRIPTION_HIDE_ONFILE_TOGGLE);
			};
		}
	} //end object


	// Expose to the global scope.
    if (typeof window.COSTCO === "undefined") {
        window.COSTCO = new Object();
    } 
	
    window.COSTCO.rxPrescriptionStatus = rxPrescriptionStatus;
		
	return rxPrescriptionStatus;
    
});



// WEBPACK FOOTER //
// ./js/rx/rxprescriptionstatus.js